import { useEffect } from 'react';
import { Typography, Row } from 'antd';
import { I18n } from '@aws-amplify/core';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

import { usePsychosocialAvaliationContext } from '../../context';
import { StyledCard, CenteredCol } from './styles';

const { Title } = Typography;

export function SuccessScreen() {
	const history = useHistory();
	const { resetSurvey, nextStep, surveyData } = usePsychosocialAvaliationContext();
	const employeeId = surveyData?.participation?.employee_id;
	const isLoggedIn = localStorage.getItem('info_user');
	const surveyId = surveyData?.participation?.survey_id;

	useEffect(() => {
		let timer: NodeJS.Timeout | undefined;

		if (employeeId) {
			timer = setTimeout(() => nextStep(), 3000);
		} else if (isLoggedIn && surveyId) {
			timer = setTimeout(() => {
				resetSurvey();
				history.push(`/psychosocial-report/survey-management/informations/${surveyId}`);
			}, 3000);
		}

		return () => {
			if (timer) clearTimeout(timer);
		};
	}, [employeeId, isLoggedIn, surveyId, nextStep, resetSurvey, history]);

	return (
		<Row justify="center">
			<CenteredCol span={24}>
				<StyledCard style={{ textAlign: 'center', padding: '2rem' }}>
					<CheckCircleOutlined style={{ fontSize: '64px', color: '#52c41a', marginBottom: '1rem' }} />
					<Title level={2}>{I18n.get('Survey completed successfully!')}</Title>
				</StyledCard>
			</CenteredCol>
		</Row>
	);
}
